import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_PARCEL_PRICE,
  CLEAR_PARCEL_PRICES,
  FLAG_GETTING_PARCEL_PRICES,
  FLAG_PARCEL_PRICE_ACTIVITY,
  GET_PARCEL_PRICE,
  GET_PARCEL_PRICES,
} from '../../../actions/types/cargo/ParcelPrice';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_PARCEL_PRICES:
      return state.setIn(['all', 'loading'], payload);
    case GET_PARCEL_PRICES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_PARCEL_PRICES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_PARCEL_PRICE_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_PARCEL_PRICE:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_PARCEL_PRICE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
